import { useState } from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

export function SubmitConfirm({ open, count, onCancel, onConfirm, submitting }) {
  const [comments, setComments] = useState("");
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-maroon-dark/40 backdrop-blur-sm" data-testid="submit-confirm">
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="bg-cream rounded-2xl p-7 max-w-md w-full border border-maroon/15 shadow-2xl">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-11 h-11 rounded-full bg-maroon/10 flex items-center justify-center"><CheckCircle2 className="w-5 h-5 text-maroon" /></div>
          <h3 className="font-serif text-2xl text-ink">Submit your album</h3>
        </div>
        <p className="text-sm text-ink/60">You have selected <span className="text-maroon font-medium">{count} photo{count !== 1 ? "s" : ""}</span> for your album. Submit these selections to your photographer?</p>
        <textarea value={comments} onChange={(e) => setComments(e.target.value)} rows={3} data-testid="submit-comments"
          placeholder="Add a note for your photographer (optional)…"
          className="mt-4 w-full bg-white border border-maroon/15 rounded-xl px-4 py-3 text-ink text-sm outline-none focus:border-gold" />
        <div className="flex gap-3 mt-5">
          <button onClick={onCancel} className="flex-1 bg-white border border-maroon/15 rounded-full py-2.5 text-ink text-sm hover:border-gold">Keep selecting</button>
          <button data-testid="confirm-submit" onClick={() => onConfirm(comments)} disabled={submitting} className="flex-1 bg-maroon text-cream rounded-full py-2.5 text-sm font-medium hover:bg-maroon-dark disabled:opacity-60">
            {submitting ? "Submitting…" : "Submit selection"}
          </button>
        </div>
      </motion.div>
    </div>
  );
}

export function SubmitSuccess({ open, count, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-maroon-dark/50 backdrop-blur-sm" data-testid="submit-success">
      <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="bg-cream rounded-2xl p-9 max-w-md w-full text-center border border-gold/40 shadow-2xl">
        <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.1, type: "spring" }} className="w-16 h-16 rounded-full bg-maroon flex items-center justify-center mx-auto mb-5">
          <CheckCircle2 className="w-8 h-8 text-cream" />
        </motion.div>
        <h3 className="font-serif text-3xl text-ink">Selection Submitted</h3>
        <p className="text-ink/60 mt-3">Your photographer has received your album selection of <span className="text-maroon font-medium">{count}</span> photos. They'll be in touch soon!</p>
        <button data-testid="success-close" onClick={onClose} className="mt-6 bg-maroon text-cream rounded-full px-8 py-2.5 font-medium hover:bg-maroon-dark">Done</button>
      </motion.div>
    </div>
  );
}
